import styled from '@emotion/styled';
import { semantic_colors, shapes, text_styles } from '../../foundation';

export const PopoverRoundedBase = styled.div<{ arrow: boolean }>`
  position: relative;
  background: ${semantic_colors.background.surface};
  color: ${semantic_colors.content.primary};
  border: none;
  ${shapes.border_radius.small};
  ${text_styles.Body_13_Regular};
  ${shapes.shadow.low};

  .pds-popover__arrow {
    position: absolute;
    width: 13px;
    height: 13px;
  }

  .pds-popover__arrow {
    &.bottom,
    &.bottom-end {
      transform: rotate(180deg);
    }
    &.left,
    &.left-end {
      transform: rotate(-90deg);
    }
    &.right,
    &.right-end {
      transform: rotate(90deg);
    }
  }
`;
